import { firebase } from './../tools/tools';
import { Observable } from 'rxjs/Observable';
import { GenericModel } from './../models/generic.model';

export class UsersModel extends GenericModel{
  /* ************************************************
  //Alta de los datos del dominio
  ************************************************ */
  createUser( _user : any, url: string ){
    var uid;
    var imagen_url;

    /*
      Verificación si existe un usuario a modificar sino lo crea
     */
    if(!_user.clave){
      uid = null;
    }else{
      uid = _user.clave;
    }

    /*
      Validación de la url de la imagén
     */
    if(url !== ""){
      //Si se mando una nueva se guarda en auxiliar
      imagen_url = url;
    }else{
      if(_user.imagen !== "")
      {
        imagen_url = _user.imagen;
      }
      else
      {
        imagen_url = "https://qserver-6e3b7.firebaseapp.com/assets/images/users/Q-icon.png";
      }
    }
    /*
      Objeto a guardar
    */
    var user:User = {
      clave:uid,
      nombre: _user.nombre,
      rol: _user.rol,
      correo: _user.correo,
      password: _user.password,
      imagen : imagen_url,
    };

    if(uid !== null){
      var editUser = firebase.functions().httpsCallable('editUser');
      return editUser(user).then(function(result) {
        // Read result of the Cloud Function.
        var sanitizedMessage = result;
        return sanitizedMessage;
      }).catch(function(error){
        // Getting the Error details.
        /*
        var code = error.code;
        var message = error.message;
        var details = error.details;
        */
        return error;
        // ...
      });

    }else{
      var createUser = firebase.functions().httpsCallable('createUser');
      return createUser(user).then(function(result) {
        // Read result of the Cloud Function.
        var sanitizedMessage = result;
        return sanitizedMessage;
      }).catch(function(error){
        // Getting the Error details.
        return error;
        // ...
      });
    }
  }

  /* ************************************************
  //Borrar los datos del usuario
  ************************************************ */

  deleteUser(id: string){
    var deleteUser = firebase.functions().httpsCallable('deleteUser');
    return deleteUser(id).then(function(result) {
      // Read result of the Cloud Function.
      firebase.database().ref(`users/${id}`).remove();
      return result;
    }).catch(function(error){
      // Getting the Error details.
      return error;
      // ...
    });
  }

/* ************************************************
//Obtener los datos del usuario
************************************************ */

  getUsers(){
    return new Observable<Array<User>>(observable => {
      var functionReturnValues = () => {
        firebase.database().ref("users").once("value").then( snapshot => {
          var array = [];
          snapshot.forEach( child_snapshot => {
            var model = child_snapshot.val() as User;
            array.push( model );
          });
          observable.next(array);
        });
      }

      functionReturnValues();
      firebase.database().ref(`users`).on('child_added', functionReturnValues);
      firebase.database().ref(`users`).on('child_changed', functionReturnValues);
      firebase.database().ref(`users`).on('child_removed', functionReturnValues);
    });
  }

  getCurrentUser(email:string){
    return new Observable<Array<User>>(observable => {
      var functionReturnValues = () => {
        firebase.database().ref("users").orderByChild("correo").equalTo(email).limitToFirst(1).once("value").then( snapshot => {
          var array = [];
          snapshot.forEach( child_snapshot => {
            var model = child_snapshot.val() as User;
            array.push( model );
          });
          observable.next(array);
        });
      }

      functionReturnValues();
      firebase.database().ref(`users`).on('child_added', functionReturnValues);
      firebase.database().ref(`users`).on('child_changed', functionReturnValues);
      firebase.database().ref(`users`).on('child_removed', functionReturnValues);
    });

  }
}

export interface User{
  nombre:string;
  rol: string;
  correo:string;
  password:string;
  clave: string;
  imagen: string;
}
